export default function (to, from, next) {
  const token = String(localStorage.getItem('auth-token'));

  if (!token || token.trim() !== 'null') {
    return next('/dashboard/main');
  }

  return next();
}
